import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for CreateTaskFromMessageStore, for use in the registry */ export const CreateTaskFromMessageStoreActionTypes = [
    ActionType.CreateBasicTaskFailedAction,
    ActionType.CreateBasicTaskSucceededAction,
    ActionType.UpdateTaskCreationStateAction,
    ActionType.CreatePremiumTaskSucceededAction,
    ActionType.CreatePremiumTaskFailedAction
];
